import { Link, useLocation } from '@tanstack/react-router';
import { Menu } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { landingContent } from '@/constants/landing-content';

const { navbar } = landingContent;

export function Navbar() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleNavClick = (href: string) => {
    if (isHomePage) {
      const id = href.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/${href}`;
    }
  };

  return (
    <header className="border-border/40 bg-background/95 supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50 w-full border-b backdrop-blur">
      <div className="container mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
        <Link to="/" className="flex items-center">
          <img src="/images/logo-text.png" alt="eumimo" className="h-7" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden items-center gap-6 md:flex">
          {navbar.links.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-muted-foreground hover:text-foreground text-sm font-medium transition-colors"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden items-center gap-4 md:flex">
          <Button asChild variant="ghost" size="sm">
            <Link to="/login">{navbar.loginLink}</Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/registration">{navbar.cta}</Link>
          </Button>
        </div>

        {/* Mobile Menu */}
        <Sheet>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon">
              <Menu className="h-5 w-5" />
              <span className="sr-only">Menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px]">
            <SheetHeader>
              <SheetTitle>
                <img src="/images/logo-text.png" alt="eumimo" className="h-6" />
              </SheetTitle>
            </SheetHeader>
            <nav className="mt-8 flex flex-col gap-4">
              {navbar.links.map((link) => (
                <button
                  key={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="text-foreground hover:text-primary py-2 text-left text-base font-medium transition-colors"
                >
                  {link.label}
                </button>
              ))}
              <hr className="border-border my-2" />
              <Button asChild variant="outline" className="w-full">
                <Link to="/login">{navbar.loginLink}</Link>
              </Button>
              <Button asChild className="w-full">
                <Link to="/registration">{navbar.cta}</Link>
              </Button>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
